import * as api from './index';

export function getUsers(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/users?${queryString}`);
}

export function getUser(id) {
    return api.get(`/users/${id}`);
}

export function updateUser(user) {
    return api.patch(`/users/${user.id}`, user);
}

export function createManager(manager) {
    return api.post('/users/createManager', manager);
}

export function createDriver(driver) {
    return api.post('/users/createDriver', driver);
}

export function setIsActiveUser(user, isActive) {
    return api.patch(`/users/${user.id}/isActive`, { isActive });
}

export function softDeleteUser(user) {
    return api.del(`/users/${user.id}/soft`);
}

export function changePassword(userId, payload) {
    return api.post(`/users/${userId}/changePassword`, payload);
}

export function requestPasswordReset(email) {
    return api.post('/requestPasswordReset', { email });
}

export function resetPassword(payload) {
    return api.post('/passwordReset', payload);
}

export function requestEmailChange(payload) {
    return api.post('/requestEmailChange', payload);
}

export function confirmEmailChange(token) {
    return api.post('/confirmEmailChange', token);
}

export function checkEmail(email) {
    return api.post('/users/checkEmail', { email });
}

export function createOwner(payload) {
    return api.post('/users/createOwner', payload);
}

export function updateUserSettings(userId, settings) {
    return api.patch(`/users/${userId}`, { settings });
}

export function changeDriverPassword(driverId, password) {
    return api.post(`/users/${driverId}/changeDriverPassword`, { password });
}
